module.exports = __webpack_public_path__ + "assets/img/29_677.46ccefdb.jpg";